import { action, makeObservable, observable, runInAction } from 'mobx';
import { Inject, Service } from 'typedi';
import { AdminRequest } from '../api/requests/AdminRequest';
import { IAdminSettings, TAdminSetting } from '../types/adminSettings';

@Service()
export class AdminSettingsService {

  @Inject(() => AdminRequest)
  private adminRequest: AdminRequest;

  @observable.ref settings: IAdminSettings = null;

  constructor() {
    makeObservable(this);
  }

  init = () => {
    if(!this.settings) this.getSettings();
  }
  /** экшен обновления статуса авторизации */
  @action getSettings = () => {
    this.adminRequest.getAllAdminSettings()
      .then((resp) => runInAction(() => this.settings = resp.data.adminSettings));
  };

  getSetting = (setting: TAdminSetting) => {
    return this.adminRequest.getAdminSetting(setting);
  }
}
